import {Controller} from "@hotwired/stimulus"
import {useIntersection} from "stimulus-use"
import ajax from "../ajax"

class InfiniteScrollingController extends Controller {
  static values = {url: String, totalPages: Number, currentPage: Number}
  connect() {
    useIntersection(this)
  }

  appear(entry) {
    if (!entry.isIntersecting) return
    if (this.currentPageValue >= this.totalPagesValue) return

    const url = new URL(this.urlValue, window.location)
    url.searchParams.append("page", this.currentPageValue + 1)
    ajax.get_turbo_stream(url.toString()).then(html => {
      window.Turbo.renderStreamMessage(html)
      this.currentPageValue++
    })
  }
}
export default InfiniteScrollingController
